import { useEffect, useRef, useState } from "react";
import textWeight from "../../utils/textWeight";
export default (options, valueName) => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const dropdownRef = useRef(null);
  const searchInputRef = useRef(null);
  const { TextWeight } = textWeight();
  const toggleDropdown = () => {
    setIsOpen(!isOpen);
    if (!isOpen) {
      // Reset search term when opening dropdown
      setSearchTerm("");
      // Focus search input after a small delay to ensure it's visible
      setTimeout(() => {
        searchInputRef.current?.focus();
      }, 100);
    }
  };

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsOpen(false);
      setSearchTerm("");
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  const filteredOptions = options.filter((option) =>
    option[valueName].toLowerCase().includes(searchTerm.toLowerCase())
  );
  return {
    dropdownRef,
    TextWeight,
    isOpen,
    setIsOpen,
    toggleDropdown,
    searchTerm,
    setSearchTerm,
    searchInputRef,
    filteredOptions,
  };
};
